/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBadge0S = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12.928 13.75c-.2.407-.51.61-.93.61s-.73-.203-.93-.61-.3-1.033-.3-1.88c0-.833.096-1.44.29-1.82.2-.387.513-.58.94-.58.426 0 .736.193.93.58.2.38.3.987.3 1.82 0 .847-.1 1.473-.3 1.88z" />
        <path d="M11.305 2.281a1 1 0 0 1 1.39 0l1.874 1.813 2.581-.365a1 1 0 0 1 1.125.817l.45 2.568 2.303 1.221a1 1 0 0 1 .43 1.323L20.313 12l1.145 2.342a1 1 0 0 1-.43 1.323l-2.302 1.221-.45 2.568a1 1 0 0 1-1.126.817l-2.581-.365-1.874 1.813a1 1 0 0 1-1.39 0L9.43 19.906l-2.58.365a1 1 0 0 1-1.126-.817l-.45-2.568-2.303-1.222a1 1 0 0 1-.43-1.322L3.687 12 2.542 9.658a1 1 0 0 1 .43-1.323l2.303-1.221.45-2.568A1 1 0 0 1 6.85 3.73l2.581.365zM9.918 14.67c.473.64 1.166.96 2.08.96.913 0 1.606-.32 2.08-.96.473-.64.71-1.573.71-2.8 0-2.447-.93-3.67-2.79-3.67s-2.79 1.223-2.79 3.67c0 1.227.236 2.16.71 2.8z" />
      </g>
    </g>
  </Icon>
);
export { SvgBadge0S as Badge0S };
